import { render, staticRenderFns } from "./TeachersDashboard.vue?vue&type=template&id=69414b81&scoped=true&"
import script from "./TeachersDashboard.vue?vue&type=script&lang=js&"
export * from "./TeachersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeachersDashboard.vue?vue&type=style&index=0&id=69414b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69414b81",
  null
  
)

export default component.exports